module.exports = __webpack_public_path__ + "static/media/ic_wcag_disability.5f1b8c83.svg";